// extracted by mini-css-extract-plugin
export default {"navIcon":"gaR5dwi_cHWivcSgFIWH","cartLink":"lhJoSyy7iwCbfITTaVpQ","quantity":"HmsadlLZid9oYz9IfaPv"};